import { useCallback, useState } from "react";
import { FlatList, Modal, Platform, Pressable, Text, View } from "react-native";
import MaterialCommunityIcons from "react-native-vector-icons/MaterialCommunityIcons";
import styles from "./Dropdown.styles";
import { DropdownProps } from "./Dropdown.types";

export default function Dropdown<T>({ value, options, emptyText, titre, subElement, style, onSelectOption, getText, getSubText }: DropdownProps<T>){
    const [modalVisible, setModalVisible] = useState(false);
    // Fermer la modale (prévenir freeze iOS)
    const closeModalSafely = useCallback(() => {
        setModalVisible(false)

        if (Platform.OS === 'ios') {
            requestAnimationFrame(() => {
            // éventuel setState si besoin
            })
        }
    }, [setModalVisible])
    // Ouverture de la modale
    const handleSelectorClick = useCallback(async () => {
        setModalVisible(true)
    }, [setModalVisible])
    const handleSelectOption = useCallback((item: T) => () => {
        onSelectOption(item)
        closeModalSafely();
    }, [closeModalSafely, onSelectOption])
    return(
        <>
            <View style={[styles.optionContainer, style]}>
                <Pressable
                    onPress={handleSelectorClick}
                    style={styles.optionButton}
                    testID="BT_CHOIX_NATURE"
                >
                <Text
                    style={
                        value
                            ? styles.optionText
                            : styles.optionPlaceholder
                    }
                >
                    {value || emptyText}
                </Text>
                <MaterialCommunityIcons
                    name="chevron-down"
                    size={25}
                    color="#6b7280"
                />
                </Pressable>
                {subElement}
            </View>
            <Modal
                visible={modalVisible}
                animationType="slide"
                transparent={false}
                onRequestClose={closeModalSafely}
            >
                <View style={styles.modalContainer}>
                    <View style={styles.modalHeader}>
                        <Text style={styles.modalTitle}>
                            {titre || "Nature d'absence"} ({options.length})
                        </Text>
                        <Pressable
                            onPress={closeModalSafely}
                            testID="BT_EXIT_MODAL"
                        >
                            <MaterialCommunityIcons
                                name="close"
                                size={24}
                                color="#666"
                            />
                        </Pressable>
                    </View>
                    <FlatList
                        data={options}
                        renderItem={({item}) => (
                            <Pressable
                                onPress={handleSelectOption(item)}
                                style={styles.modalItem}
                            >
                                <View style={styles.modalItemContent}>
                                    {getText(item)}
                                    {getSubText && getSubText(item)}
                                </View>
                            </Pressable>
                        )}
                    />
                </View>
            </Modal>
        </>
    )
}
